import React, { ReactNode } from "react";
import { sendErrorLog } from "./sendErrorLog";

interface ErrorBoundaryProps {
    children: ReactNode;
}

interface ErrorBoundaryState {
    hasError: boolean;
}

export default class ErrorBoundary extends React.Component<
    ErrorBoundaryProps,
    ErrorBoundaryState
> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(): ErrorBoundaryState {
        return { hasError: true };
    }

    componentDidCatch(error: unknown, info: any) {
        const errorMessage = error instanceof Error ? error.message : String(error);

        // Auto-reload on Chunk Load Error (Version Mismatch)
        if (errorMessage.includes("Loading chunk") || errorMessage.includes("missing")) {
            const hasReloaded = sessionStorage.getItem("chunk_reload_lock");
            if (!hasReloaded) {
                sessionStorage.setItem("chunk_reload_lock", "true");
                window.location.reload();
                return;
            }
        }

        sendErrorLog({
            type: "renderError",
            message: errorMessage,
            stack: info?.componentStack,
        });
    }

    render() {
        if (this.state.hasError) {
            return (
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "100vh",
                        textAlign: "center",
                        fontFamily: "sans-serif",
                        padding: "20px",
                        backgroundColor: "#f8f9fa",
                    }}
                >
                    <h2 style={{ marginBottom: "16px", color: "#343a40" }}>
                        Bir hata oluştu
                    </h2>
                    <p style={{ marginBottom: "24px", color: "#6c757d", maxWidth: "400px" }}>
                        Beklenmedik bir sorunla karşılaştık. Lütfen sayfayı yenilemeyi deneyin.
                        Sorun devam ederse lütfen destek ekibi ile iletişime geçin.
                    </p>
                    <button
                        onClick={() => {
                            sessionStorage.removeItem("chunk_reload_lock");
                            window.location.reload();
                        }}
                        style={{
                            padding: "12px 24px",
                            fontSize: "16px",
                            fontWeight: 500,
                            backgroundColor: "#0d6efd",
                            color: "white",
                            border: "none",
                            borderRadius: "6px",
                            cursor: "pointer",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                            transition: "background-color 0.2s",
                        }}
                    >
                        Sayfayı Yenile
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}
